import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "textarea", "input", "fieldset", "editButton", "saveButton"]

  edit() {
    this.displayTargets.forEach((el) => el.classList.add("hidden"))
    this.formTarget.classList.remove("hidden")
    if (this.hasEditButtonTarget) {
      this.editButtonTarget.hidden = true
    }
    if (this.hasSaveButtonTarget) {
      this.saveButtonTarget.hidden = false
    }
    if (this.hasFieldsetTarget) {
      this.fieldsetTarget.disabled = false
    }
    if (this.hasInputTarget) {
      const input = this.inputTarget
      input.focus()
      input.select()
    } else if (this.hasTextareaTarget) {
      const ta = this.textareaTarget
      this.resize(ta)
      ta.focus()
      ta.select()
    }
    this.relayoutMaps()
  }

  cancel() {
    this.formTarget.classList.add("hidden")
    this.displayTargets.forEach((el) => el.classList.remove("hidden"))
    if (this.hasEditButtonTarget) {
      this.editButtonTarget.hidden = false
    }
    if (this.hasSaveButtonTarget) {
      this.saveButtonTarget.hidden = true
    }
    if (this.hasFieldsetTarget) {
      this.fieldsetTarget.disabled = true
    }
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.formTarget.querySelector("form")?.requestSubmit()
    }
  }

  autoResize(event) {
    this.resize(event.target)
  }

  relayoutMaps() {
    requestAnimationFrame(() => {
      this.formTarget.querySelectorAll("[data-controller~='google-map']").forEach((el) => {
        this.application.getControllerForElementAndIdentifier(el, "google-map")?.relayout()
      })
    })
  }

  // Runtime DOM measurement — scrollHeight depends on the textarea's current
  // content and width, which can't be expressed as a pre-defined CSS class.
  resize(el) {
    el.style.height = "auto"
    el.style.height = `${el.scrollHeight}px`
  }
}
